import type { ComponentType } from 'react';
import type { ClassNameProp } from '@utils';
import AC from './ac';
import Accessible from './accessible';
import Concessions from './concessions';
import Drinking from './drinking';
import Heat from './heat';
import Lights from './lights';
import LockerRoom from './lockerRoom';
import PaidParking from './paidParking';
import Parking from './parking';
import PortableRestrooms from './portableRestrooms';
import Restrooms from './restrooms';
import Shelters from './shelters';
import Wifi from './wifi';

export {
	AC,
	Accessible,
	Concessions,
	Drinking,
	Heat,
	Lights,
	LockerRoom,
	PaidParking,
	Parking,
	PortableRestrooms,
	Restrooms,
	Shelters,
	Wifi,
};

export const amenityIconByKey: Record<string, ComponentType<ClassNameProp>> = {
	am_ac: AC,
	am_accessible: Accessible,
	am_concessions: Concessions,
	am_drinking: Drinking,
	am_heat: Heat,
	am_lights: Lights,
	am_lockerRoom: LockerRoom,
	am_paidParking: PaidParking,
	am_parking: Parking,
	am_portableRestrooms: PortableRestrooms,
	am_restrooms: Restrooms,
	am_shelters: Shelters,
	am_wifi: Wifi,
};
